/* eslint-disable @typescript-eslint/no-explicit-any */
import { CommonModule } from '@angular/common';
import { Component, DestroyRef, OnInit, ViewChild, ViewContainerRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SharingDataService } from 'src/app/shared/service/sharing-data.service';
import { TranslationService } from 'src/app/shared/service/translation.service';
import { AliasListComponent } from '../../alias-list/alias-list.component';

const CONTENT_MODERATION_PROFILES = ['MBRDI-Developer', 'MBRDI-Testers'];
@Component({
  selector: 'app-group-section',
  templateUrl: './group-section.component.html',
  styleUrls: ['./group-section.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslateModule, AliasListComponent],
})
export class GroupSectionComponent implements OnInit {
  // Feature flags
  public enableManageBusiness: boolean = false;
  public enableManageFleet: boolean = false;
  public enableContentModeration: boolean = false;
  public isModerationEnabled: boolean = false;

  private readonly route = inject(Router);
  private readonly dataSharing = inject(SharingDataService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly translationService = inject(TranslationService);

  @ViewChild('viewContainerRef', { read: ViewContainerRef, static: true })
  public viewContainer: ViewContainerRef | undefined
  groupName: any
  profileswitchselected: boolean = false
  translationData: any
  profileImage: any


  ngOnInit(): void {
    this.dataSharing.getProfileChanged().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.groupName = localStorage.getItem('profileName')
      this.profileImage = localStorage.getItem('profileImage')
      this.enableContentModeration = this.translationService.featureFlags.profile.enableContentModeration
      this.isModerationEnabled = this.enableContentModeration && CONTENT_MODERATION_PROFILES.includes(this.groupName)
    })
    this.groupName = localStorage.getItem('profileName')
    this.profileImage = localStorage.getItem('profileImage')
    this.enableContentModeration = this.translationService.featureFlags.profile.enableContentModeration
    this.isModerationEnabled = this.enableContentModeration && CONTENT_MODERATION_PROFILES.includes(this.groupName);
    this.enableManageBusiness = this.translationService.featureFlags.profile.enableManageBusiness;
    this.enableManageFleet = this.translationService.featureFlags.profile.enableManageFleet;
  }


  manageBusiness() {
    this.dataSharing.setMobileMenuStatus(false);
    this.route.navigate(['profile/member-list'])
    this.dataSharing.setProfileDetailsClicked(true)
  }
  switchProfile(event: any) {
    event.stopPropagation();
    this.profileswitchselected = true
    this.dataSharing.setProfileSwitched(true)
    localStorage.setItem("isProfileChanged", 'true')
  }
  contentModeration() {
    this.dataSharing.setMobileMenuStatus(false);
    this.route.navigate(['/profile/content-moderation'])
  }

  public myFleets(): void {
    this.dataSharing.setMobileMenuStatus(false);
    this.route.navigate(['profile/fleet'])
  }
}
